import React from "react";

/*
    A plain spinning icon, for buttons that are working.

    reactstrap's <Spinner> renders the Bootstrap rotating-border animation —
    the "rotating search animation" that was on the Search and Create
    credentials buttons. This is the simple icon version asked for instead.

    Font Awesome 6 is already loaded globally from public/index.html, so this
    adds no dependency; `fa-circle-notch` is FA's spinner glyph and `fa-spin`
    its own rotation, so there is no new keyframe either.
*/
const SpinnerIcon = ({ className = "", label = "Working" }) => (
  <i
    className={`fas fa-circle-notch fa-spin ${className}`}
    role="status"
    aria-label={label}
  />
);

export default SpinnerIcon;
